import { External_AWS_CDK_Config, InterfaceEndpointDeploymentMap } from '@iotv/iotv-v3-types'
import { resolvedEnvironmentVariables } from './resolvedEnvironmentVariables'
import type { ComparisonOperator, TreatMissingData } from 'aws-cdk-lib/aws-cloudwatch'
import { parentHostedZoneName } from '../../../domainAccountConfig'

const { default_region, region, accountId, projectCode, appName, stage } = resolvedEnvironmentVariables

const defaultInterfaceEndpointDeployment: InterfaceEndpointDeploymentMap = {
  dev: {
    timestream: false,
    cloudwatch: false,
    sns: false,
  },
  test: {
    timestream: false,
    cloudwatch: false,
    sns: false,
  },
  prod: {
    timestream: true,
    cloudwatch: true,
    sns: true,
  },
}

export const defaultAWSCDKConfig: External_AWS_CDK_Config = {
  Cognito: {
    groupDefinitions: [],
    userInvitationConfig: {
      emailSubject: `${projectCode.substring(0, 4)}-${stage} User Registration`,
      emailBody: `{username}, you have been invited to register as a user of ${projectCode.substring(0, 4)} at app.${stage}.${projectCode.substring(0, 4)}.${parentHostedZoneName}
            Your password is {####}, this can be changed after logging in.`,
    },
  },
  Lamdba: {
    [`${projectCode}-${stage}-CalculatedState`]: {
      projectFunctionProps: {
        environment: {
          DEFAULT_CANARY_ENV: 'DEFAULT',
          CANARY_TEST_ENVARS: 'DEFAULT',
        },
      },
      /** used by cloudwatch alerts to configure settings for this lambda */
      alarmConfig: {
        metricInvocations: {
          threshold: 1,
          evaluationPeriods: 1,
          alarmDescription: 'Alarm if Calculate state is involed less than once in 1 evaluation period',
          comparisonOperator: 'LessThanThreshold' as ComparisonOperator.LESS_THAN_THRESHOLD,
          treatMissingData: 'breaching' as TreatMissingData.BREACHING,
        },
      },
    },
  },
  VPC: {
    interfaceEndpointDeployment: defaultInterfaceEndpointDeployment,
  },
}
